export default __webpack_public_path__ + "static/media/payment.9fd406dd.png";